var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_cof.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_cof.js
// module chunks = 6